import { useState } from 'react'
import { motion } from 'framer-motion'
import { Card, CardContent } from '@/components/ui/card'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { SavedAccountsList } from './saved-accounts-list'
import { GlobalAccountsList } from './global-accounts-list'

interface AccountSelectionTabsProps {
  selectedAccounts: string[]
  onAccountToggle: (accountId: string) => void
}

const tabsVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 }
}

export function AccountSelectionTabs({ selectedAccounts, onAccountToggle }: AccountSelectionTabsProps) {
  const [activeTab, setActiveTab] = useState('saved')

  return (
    <motion.div
      variants={tabsVariants}
      initial="hidden"
      animate="visible"
      transition={{ delay: 0.2, duration: 0.6, ease: "easeOut" }}
    >
      <Card>
        <CardContent className="p-0">
          <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
            <div className="p-4 pb-0">
              <TabsList className="grid w-full grid-cols-2">
                <TabsTrigger value="saved">Saved Accounts</TabsTrigger>
                <TabsTrigger value="global">Global Accounts</TabsTrigger>
              </TabsList>
            </div>
            
            <TabsContent value="saved" className="mt-4 p-4 pt-0">
              <SavedAccountsList 
                selectedAccounts={selectedAccounts}
                onAccountToggle={onAccountToggle}
              />
            </TabsContent>
            
            <TabsContent value="global" className="mt-4 p-4 pt-0">
              <GlobalAccountsList 
                selectedAccounts={selectedAccounts}
                onAccountToggle={onAccountToggle}
              />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </motion.div>
  )
} 